//imagenconinformacion__item
import $ from "jquery";

$('.imagenconinformacion__item').on('show.bs.collapse', function (event) {
    let pos = $(event.target).attr('data-posicion');
    $('[data-target="#multiCollapse-'+pos+'"]').parent().addClass('d-none');
    
 });

 /*$('.multi-collapse').on('click', function (event) {
    let id = event.currentTarget.id;
    console.log($('[data-target="#'+id+'"]').parent());
    $('[data-target="#'+id+'"]').parent().removeClass('d-none');
    $(event.currentTarget).toggle();
    
 });*/